<template>
  <section>
    <leo-dialog :show="isShow" persistence maxWidth="704px">
      <leo-button
        fab
        @click="$emit('on-close')"
        class="leo-bg-white leo-absolute leo-top-0 leo-right-0 leo-mt-xs leo-mr-xs leo-button leo-button--type-fab"
      >
        <leo-icon type="close" size="md" width="12px" height="12px"/>
      </leo-button>
      <div class="leo-m-auto">
        <div
          class="leo-text-lg leo-text-secondary leo-font-semibold"
        >
          {{ contactProps.heading }}
        </div>
        <div class="leo-flex leo-flex-col leo-pt-md">
          <div class="leo-text-md leo-text-accent">
            {{ contactProps.subheading }}
          </div>
          <!-- <div class="leo-text-md leo-text-accent">
            {{ contactProps.label1 }}
          </div> -->
          <div class="leo-flex leo-flex-row leo-justify-between leo-py-sm leo-px-md" @click="onClickCallNumber">
            <div>
              <leo-icon color="primary" type="call"></leo-icon>
              <span
                :class="['leo-pl-xs', 'leo-text-primary', 'leo-text-sm', 'tablet:leo-text-md', 'leo-font-semibold', isDesktopChannel ? '' : 'leo-cursor-pointer' ]"
              >
                {{ isGELS ? contactProps.callNumberSG : contactProps.callNumberMY }}
              </span>
            </div>
          </div>
          <div class="leo-flex leo-flex-row leo-justify-between leo-py-sm leo-px-md" @click="onClickEmail">
            <div>
              <leo-icon color="primary" type="email"></leo-icon>
              <span
                class="leo-pl-xs leo-text-primary leo-text-sm tablet:leo-text-md leo-font-semibold leo-cursor-pointer"
              >
                {{ isGELS ? contactProps.emailSG : contactProps.emailMY }}
              </span>
            </div>
          </div>
          <!-- <br />
          <div class="leo-text-md leo-text-accent">
            {{ contactProps.label2 }}
          </div>
          <div class="leo-flex leo-flex-row leo-justify-between">
            <div>
              <leo-icon color="primary" type="call"></leo-icon>
              <span
                class="leo-pl-2xs leo-text-secondary leo-text-sm tablet:leo-text-md leo-font-semibold"
              >
                {{ contactProps.callLabel }}
              </span>
            </div>
            <div class="leo-text-sm tablet:leo-text-md leo-text-accent">
              {{ contactProps.callNumber3 }}
            </div>
          </div>
          <div class="leo-flex leo-flex-row leo-justify-between">
            <div>
              <leo-icon color="primary" type="unread"></leo-icon>
              <span
                class="leo-pl-2xs leo-text-secondary leo-text-sm tablet:leo-text-md leo-font-semibold"
              >
                {{ contactProps.emailLabel }}
              </span>
            </div>
            <div class="leo-text-sm tablet:leo-text-md leo-text-accent">
              {{ contactProps.email2 }}
            </div>
          </div> -->
        </div>
      </div>
    </leo-dialog>
  </section>
</template>

<script>
import { VueLeoButton } from "@greateasternlife/leo-button";
import { VueLeoDialog } from "@greateasternlife/leo-dialog";
import { VueLeoIcon } from "@greateasternlife/leo-icon";
import { CommonClass } from "@/mixins";
import sessionStorageUtils from "@/utils/session-storage";
export default {
  name: "ContactUs",
  components: {
    "leo-dialog": VueLeoDialog,
    "leo-button": VueLeoButton,
    "leo-icon": VueLeoIcon,
  },
  mixins: [CommonClass],
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contactProps: this.$getConstant.contactUsProp,
      isGELS: sessionStorageUtils.getItem("appCountry") == 'sg',
      isDesktopChannel: this.$__checkIsDesktopChannel(),
    };
  },
  methods: {
    onClickCallNumber() {
      if (this.isDesktopChannel) { 
        return
      }
      const phoneNumber = this.isGELS ? this.contactProps.callNumberSG : this.contactProps.callNumberMY
      window.location.href = `tel:${phoneNumber}`;
    },
    onClickEmail() {
      const toPerson = this.isGELS ? this.contactProps.emailSG : this.contactProps.emailMY
      window.location.href = `mailto:${toPerson}`
    },
  },
};
</script>
